import React from "react";

import { Messages } from "../../helpers/message-helper";

/**
 * Componente que representa el formulario de alta y modificación de un
 * recurso.
 */
export default class BaseForm extends React.Component {
  state = {
    loading: false
  };

  message = {
    "confirm.message": "BaseForm.agregar.confirm",
    "agregar.success": "BaseForm.agregar.success",
    "agregar.error": "BaseForm.agregar.error",
    "obtener.error": "BaseForm.obtener.error"
  };

  api = null;

  alert = React.createRef();

  /**
   * Se encarga de recupera los datos de cuando el componente se monta.
   */
  componentDidMount() {
    if (!this.isCrear()) {
      this.obtener();
    }
  }

  isCrear() {
    return !(
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.id
    );
  }

  obtener() {
    this.setState({ loading: true });

    let promise = this.api.obtener(this.props.match.params.id);
    promise
      .then(response => {
        this.setState(response.data);
        this.setState({ loading: false });
      })
      .catch(error => {
        this.alert.open({
          title: "Error!",
          message: Messages.get(this.message["obtener.error"])
        });
      });
    return promise;
  }

  /**
   * Se encarga de manejar el success del guardar de los datos.
   * @param {*} data
   */
  guardarSuccess(data) {
    this.alert.open({
      title: "Atención!",
      message: Messages.get(this.message["agregar.success"])
    });
  }

  /**
   * Se encarga de manejar el error del guardar de los datos.
   * @param {*} error
   */
  guardarError(error) {
    this.alert.open({
      title: "Error!",
      message: Messages.get(this.message["agregar.error"])
    });
  }

  agregar(data) {
    this.api
      .agregar(data)
      .then(resp => {
        this.guardarSuccess(resp);
      })
      .catch(error => {
        this.guardarError(error);
      });
  }

  actualizar(data) {
    this.api
      .actualizar(data)
      .then(resp => {
        this.guardarSuccess(resp);
      })
      .catch(error => {
        this.guardarError(error);
      });
  }

  /**
   * Se encarga de invocar al servicio que se encarga de guardar
   * un registro.
   */
  guardar(data) {
    if (this.isCrear()) {
      this.agregar(data);
    } else {
      this.actualizar(data);
    }
  }
  /**
   * Se encarga de manejar el evento click del boton guardar.
   */
  onGuardar(evt) {
    evt.stopPropagation();
    let valid = this.form.isValid(this.state);
    console.log(valid);
    if (!valid) {
      return;
    }
    let msg = this.message;
    this.form.confirm.open({
      title: "¡Atención!",
      message: Messages.get(msg["confirm.message"]),
      yes: () => {
        this.guardar(this.state);
      }
    });
  }

  /**
   * Se encarga de manejar el evento change de los inputs.
   * @param {*} attr
   * @param {*} val
   */
  onChange(attr, val) {
    this.setState({ [attr]: val });
  }

  /**
   * Se encarga de manejar el evento change de los inputs.
   * @param {*} attr
   * @param {*} file
   */
  setFile(attr, file) {
    this.setState({ [attr]: file.fileName });
  }
}
